import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {Container} from 'reactstrap';
import FullHeader from './FullHeader';
import FullFooter from './FullFooter';
import Sidebar from 'App/components/Sidebar/';
import Breadcrumb from 'App/components/Breadcrumb/';

import * as helper from 'App/util/common/helper';
import CountDown from 'App/components/CountDown/';
import routes from 'App/routes';
import settings from 'Root/settings.json';

class Full extends Component {

  render() {
    return (
      <div>
        <div className="fixed-top">
          <CountDown/>
        </div>
        <div className="app" style={{paddingTop: '16px'}}>
          <FullHeader/>

          <div className="app-body">
            <Sidebar {...this.props}/>
            <main className="main">

              <Breadcrumb routes={routes} root={settings.routing.root}/>
              <Container fluid>
                <Switch>
                  {routes.map((route, idx) => {
                      return route.component ? (
                          <Route key={idx} path={route.root} exact={route.exact} name={route.name} render={props => (
                            <route.component {...props} {...route.props}/>
                          )}/>)
                        : (null);
                    },
                  )}
                  <Redirect exact from={helper.getPath()} to={helper.getPath('dashboard')}/>
                </Switch>
              </Container>
            </main>
          </div>
          <FullFooter lastUpdated={this.props.lastUpdated} />
        </div>
      </div>
    );
  }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js